import { FC, useMemo } from 'react';
import { useAuthContext } from '@/context/AuthContext.tsx';
import { Navigate, Outlet } from 'react-router-dom';
import Routes from '@/router/Routes.ts';
import Middleware from '@/router/middleware/index.tsx';
import { familyMemberNavData, businessProviderNavData } from '@/layouts/Default/config-nav.tsx';

const NotLoggedIn: FC = () => {
  const { isLoading, session, currentUser, isLoadingUser } = useAuthContext();

  // Get first navigation item based on user role
  const redirectPath = useMemo(() => {
    if (!session) return Routes.DASHBOARD;
    
    const userRole = currentUser?.role;
    
    if (userRole === 'admin') {
      return Routes.ADMIN_FAMILIES;
    }
    
    if (userRole === 'business_provider') {
      return businessProviderNavData[0]?.path ?? Routes.DASHBOARD;
    }
    
    // Default to family member navigation (or if no role specified)
    return familyMemberNavData[0]?.path ?? Routes.DASHBOARD;
  }, [session, currentUser]);

  return <Middleware isLoading={isLoading || isLoadingUser}>{!session ? <Outlet /> : <Navigate to={redirectPath} />}</Middleware>;
};

export default NotLoggedIn;
